import { Label } from "@components/inputs/field";
import SmartField, { ISmartFieldProps, ISmartFieldRenderProps } from "@components/smart/smartField/SmartField";
import { ISmartFieldEvents } from "@components/smart/smartField/SmartFieldUtils";
import { IPrPayslipEntity, PrPayslipDeductionEntity, PrPayslipEntity } from "@odata/GeneratedEntityTypes";
import { DeductionsWrapper } from "@pages/payroll/payslip/Payslip.styles";
import { isCustomPayslipDeduction } from "@pages/payroll/payslip/Payslip.utils";
import { memoizeOne } from "@utils/memoizeOne";
import React, { Component } from "react";

import { LabelStatus } from "../../../enums";
import { FormStorage } from "../../../views/formView/FormStorage";

export interface IProps extends Omit<ISmartFieldRenderProps, "onBlur" | "onChange" | "onRowsChange">, ISmartFieldEvents {
    storage: FormStorage<IPrPayslipEntity>;
}

export default class DeductionsEntryList extends Component<IProps> {

    getFieldProps = memoizeOne((): ISmartFieldProps['fieldProps'] => {
        return {
            labelStatus: LabelStatus.Removed,
            isWithoutRightMargin: true,
        };
    });

    // formatAmount(amount: number): string {
    //     return formatCurrency(amount, getCompanyCurrency(this.props.storage.context));
    // }

    render() {
        const { storage } = this.props;
        // const payslip = storage.data.entity as IPrPayslipEntity;
        const deductions = storage.data.entity.Deductions?.filter(isCustomPayslipDeduction);
        const deductionsBc = storage.data.bindingContext.navigate(PrPayslipEntity.Deductions);
        const fieldProps = this.getFieldProps();
        // const netSalary = payslip.Items.find(i => i.TypeCode === PrPayslipItemTypeCode.NetSalary)?.DecimalValue;
        // <FieldsWrapper>
        //     <Field label={i18next.t("Payslip:Deductions.Base")} isReadOnly>
        //         <Input value={this.formatAmount(netSalary)} name={"deductions-base"} isReadOnly/>
        //     </Field>
        // </FieldsWrapper>
        return (
                <DeductionsWrapper>
                    {deductions.map((deduction, index) => {
                        const { storage, onWidthChange, ...restProps } = this.props;
                        const bc = deductionsBc.addKey(deduction);
                        return (
                                <React.Fragment key={deduction.Id}>
                                    <Label isRequired>{deduction.Name}</Label>
                                    <SmartField storage={storage}
                                                {...restProps}
                                                bindingContext={bc.navigate(PrPayslipDeductionEntity.AmountOverride)}
                                                fieldProps={fieldProps} />
                                    <div>{/* keep the div as the field becomes invisible sometime, but we need to keep the grid */}
                                        <SmartField storage={storage}
                                                    {...restProps}
                                                    bindingContext={bc.navigate(PrPayslipDeductionEntity.CalculationTypeCode)}
                                                    fieldProps={fieldProps} />
                                    </div>
                                </React.Fragment>
                        );
                    })}
                </DeductionsWrapper>
        );
    }
}
